<script>
import ElTooltip from 'element-ui/lib/tooltip'

export default {
  name: 'ElTooltip',
  extends: ElTooltip,
  render (h) {
    const context = Object.create(this)
    Object.defineProperty(context, 'popperClass', {
      value: ['ui-tooltip-popper', this.popperClass].filter(Boolean).join(' ')
    })
    // 原 render 返回实际触发元素，同时维护挂到 body 的 popperVM。
    const vnode = ElTooltip.render.call(context, h)
    if (vnode) {
      vnode.data = vnode.data || {}
      vnode.data.class = [vnode.data.class, 'ui-tooltip-trigger']
    }
    return vnode
  }
}
</script>
